import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
const Loader = () => {
    return (_jsx("div", { className: "loader", children: _jsx("span", {}) }));
};
export default Loader;
